/**
 * @generated SignedSource<<0901887a35f1b9a1e98052eb8b2e85c2>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type TabBarNav_session$data = {
  readonly " $fragmentSpreads": FragmentRefs<"BookButton_session" | "useGetTabBarItemsFragment_session">;
  readonly " $fragmentType": "TabBarNav_session";
};
export type TabBarNav_session$key = {
  readonly " $data"?: TabBarNav_session$data;
  readonly " $fragmentSpreads": FragmentRefs<"TabBarNav_session">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "TabBarNav_session",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "useGetTabBarItemsFragment_session"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "BookButton_session"
    }
  ],
  "type": "Session",
  "abstractKey": null
};

(node as any).hash = "47403bce0e8f8ea7276a940a2909072e";

export default node;
